import React from "react";
import Price from "../Price";
import { Link } from "gatsby";
import coursePrices from "../../data/coursePrices.json";

const JapaneseCourseCard = ({ buyNow, viewCourse }) => {
  return (
    <>
      <section id="services" className="japanese-container">
        <div className={"row"}>
          <div align={"center"}>
            <br /> <br />
            <br />
            <h2 className="highlighted-text">
              {" "}
              <strong>Japanese </strong>Courses By <span className="light-text"> Koderbox</span>{" "}
            </h2>
          </div>
          <div className="japanese-courses ">
            <div className="box course-card">
              {/* <div className="discount-badge">Offer: {this.state.inIndia ? "₹6500":"$200"}</div> */}
              <Price offerPrice={true} inr={coursePrices.languages.japanese.n5.offerPrice.inr} usd={coursePrices.languages.japanese.n5.offerPrice.usd} />
              <div align="center">
                <h4 className="highlighted-text">JLPT N5 Course</h4>
              </div>{" "}
              <div>
                <ul>
                  <li>Basic Japanese</li>
                  <li>Mode: Online</li>
                  <li>Duration: 3-4 Months</li>
                  <li>Mode: Online</li>
                  <li>Certificates will be provided.</li>
                </ul>
                {/* <h4 align="center">Price: <span className="highlighted-text strike">{this.state.inIndia ? "₹9000":"$200"} </span></h4> */}
                <h4 align="center">
                  <span className="highlighted-text strike">
                    <Price originalPrice={true} inr={coursePrices.languages.japanese.n5.originalPrice.inr} usd={coursePrices.languages.japanese.n5.originalPrice.usd} />
                  </span>
                </h4>
              </div>
              {buyNow && (
                <Price buy={true} />
              )}
              {viewCourse && (
                <Link to="/japaneseclasses">
                  <button className="pay-btn" align="center">
                    View Course
                  </button>
                </Link>
              )}
            </div>
            <div className="box course-card">
              {/* <div className="discount-badge">Offer: {this.state.inIndia ? "₹7500":"$200"}</div> */}
              <Price offerPrice={true} inr={coursePrices.languages.japanese.n4.offerPrice.inr} usd={coursePrices.languages.japanese.n4.offerPrice.usd} />
              <div align="center">
                <h4 className="highlighted-text">JLPT N4 Course</h4>
              </div>
              <div>
                <ul>
                  <li>Fluent Japanese</li>
                  <li>Mode: Online</li>
                  <li>Duration:4-5 Months</li>
                  <li>Mode: Online</li>
                  <li>Certificates will be provided.</li>
                </ul>
                {/* <h4 align="center">Price:<span className="highlighted-text strike">{this.state.inIndia ? "₹10000":"$200"}</span></h4> */}
                <h4 align="center">
                  <span className="highlighted-text strike">
                    <Price originalPrice={true} inr={coursePrices.languages.japanese.n4.originalPrice.inr} usd={coursePrices.languages.japanese.n4.originalPrice.usd} />
                  </span>
                </h4>
              </div>
              {buyNow && (
                <Price buy={true} />
              )}
              {viewCourse && (
                <Link to="/japaneseclasses">
                  <button className="pay-btn" align="center">
                    View Course
                  </button>
                </Link>
              )}
            </div>
            <div className="box course-card">
              {/* <div className="discount-badge">Offer: {this.state.inIndia ? "₹7500":"$200"}</div> */}
              <Price offerPrice={true} inr={coursePrices.languages.japanese.n3.offerPrice.inr} usd={coursePrices.languages.japanese.n3.offerPrice.usd} />
              <div align="center">
                <h4 className="highlighted-text">JLPT N3 Course</h4>
              </div>
              <div>
                <ul>
                  <li>Fluent Japanese</li>
                  <li>Mode: Online</li>
                  <li>Duration:4-5 Months</li>
                  <li>Mode: Online</li>
                  <li>Certificates will be provided.</li>
                </ul>
                {/* <h4 align="center">Price:<span className="highlighted-text strike">{this.state.inIndia ? "₹10000":"$200"}</span></h4> */}
                <h4 align="center">
                  <span className="highlighted-text strike">
                    <Price originalPrice={true} inr={coursePrices.languages.japanese.n3.originalPrice.inr} usd={coursePrices.languages.japanese.n3.originalPrice.usd} />
                  </span>
                </h4>
              </div>
              {buyNow && (
                <Price buy={true} />
              )}
              {viewCourse && (
                <Link to="/japaneseclasses">
                  <button className="pay-btn" align="center">
                    View Course
                  </button>
                </Link>
              )}
            </div>
            <div className="box course-card">
              {/* <div className="discount-badge">Offer: {this.state.inIndia ? "₹7500":"$200"}</div> */}
              <Price offerPrice={true} inr={coursePrices.languages.japanese.n4n5.offerPrice.inr} usd={coursePrices.languages.japanese.n4n5.offerPrice.usd} />
              <div align="center">
                <h4 className="highlighted-text">JLPT N4+N5 Course</h4>
              </div>
              <div>
                <ul>
                  <li>Fluent Japanese</li>
                  <li>Mode: Online</li>
                  <li>Duration:4-5 Months</li>
                  <li>Mode: Online</li>
                  <li>Certificates will be provided.</li>
                </ul>
                {/* <h4 align="center">Price:<span className="highlighted-text strike">{this.state.inIndia ? "₹10000":"$200"}</span></h4> */}
                <h4 align="center">
                  <span className="highlighted-text strike">
                    <Price originalPrice={true} inr={coursePrices.languages.japanese.n4n5.originalPrice.inr} usd={coursePrices.languages.japanese.n4n5.originalPrice.usd} />
                  </span>
                </h4>
              </div>
              {buyNow && (
                <Price buy={true} />
              )}
              {viewCourse && (
                <Link to="/japaneseclasses">
                  <button className="pay-btn" align="center">
                    View Course
                  </button>
                </Link>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default JapaneseCourseCard;
